// extracted by mini-css-extract-plugin
export var avatar = "_nd-3";
export var avatarContainer = "_nd-2";
export var avatarSpacer = "_nd-5";
export var avatarSpacerContainer = "_nd-4";
export var avatarStackContainer = "_nd-1";
export var bubble = "_nd-0";
export var remainderBubble = "_nd-6";